

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import TextField from '@/components/form/TextField.vue';
import { ValidationError } from 'class-validator';
import User from '@/types/auth/User';
import CheckboxField from '@/components/form/CheckboxField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: {
    NewTranslation,
    TextField,
    CheckboxField,
  },
})
export default class RegisterStepTwo extends Vue {
  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @Prop(Object)
  private user!: User;

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.user.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.user.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.user.errors.splice(index, 1);
  }
}
